export const dataHooks = {
    input: 'checkbox-input',
    label: 'checkbox-label',
    boxTooltip: 'checkbox-box-tooltip',
    box: 'checkbox-box',
    children: 'checkbox-children',
};
export const LABEL_TEXT_SIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
};
export const SELECTION_AREA = {
    NONE: 'none',
    HOVER: 'hover',
    ALWAYS: 'always',
};
export const V_ALIGN = {
    CENTER: 'center',
    TOP: 'top',
};
export const SELECTION_AREA_SKIN = {
    FILLED: 'filled',
    OUTLINED: 'outlined',
};
//# sourceMappingURL=constants.js.map